// Typeguards
export function isEnhancedItem(loot) {
    return !(loot.equipmentCategory);
}
export function isWeaponType(loot) {
    return !isEnhancedItem(loot) && loot.equipmentCategory === 'Weapon';
}
export function isArmorType(loot) {
    return !isEnhancedItem(loot) && loot.equipmentCategory === 'Armor';
}
export function isGearType(loot) {
    return !isEnhancedItem(loot) && !['Weapon', 'Armor'].includes(loot.equipmentCategory);
}
